import ALazyLoad from './LazyLoad.vue';
export default ALazyLoad;


// WEBPACK FOOTER //
// ./src/packages/LazyLoad/index.js